import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51779527"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["href"]
const _hoisted_4 = ["href"]
const _hoisted_5 = {
  class: "foxigy-plugin",
  ref: "mainElement"
}
const _hoisted_6 = {
  class: "b bg-primary bg-img-f pt-6 widget outer-line footer bg-size-cover bg-v-center hidden-bg-img-xs",
  "data-designer-container": "ftr"
}
const _hoisted_7 = { class: "container text-c-muted max-w-xxl" }
const _hoisted_8 = {
  id: "ftr-first-row",
  class: "row text-sm-center-var ftr-top"
}
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  id: "ftr-second-row",
  class: "row text-sm-center-var ftr-top"
}
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  style: {},
  class: "col-xl-10 col-sm-14 pb-6 text-xl-left"
}
const _hoisted_13 = { class: "row" }
const _hoisted_14 = {
  "data-designer": "ftr-cu",
  class: "d-block mb-2 title col-xl-24 text-sm-center-var",
  style: {"font-size":"1.4rem"}
}
const _hoisted_15 = {
  key: 0,
  class: "col-6"
}
const _hoisted_16 = {
  key: 0,
  class: "smdWrapperTag"
}
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  "data-designer": "ftr-col-right",
  class: "col-xl-7 pb-3 img-center container"
}
const _hoisted_19 = { class: "row text-center-var" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "offset-xl-2 offset-sm-4",
  "data-v-0f01aa53": ""
}, null, -1))
const _hoisted_21 = ["src"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "offset-xl-2 offset-sm-4",
  "data-v-0f01aa53": ""
}, null, -1))
const _hoisted_23 = ["href"]
const _hoisted_24 = ["src"]
const _hoisted_25 = ["href"]
const _hoisted_26 = ["src"]
const _hoisted_27 = ["href"]
const _hoisted_28 = ["src"]
const _hoisted_29 = {
  id: "ftr-third-row",
  class: "row text-sm-center-var ftr-top"
}
const _hoisted_30 = {
  itemscope: "",
  itemtype: "http://schema.org/LocalBusiness",
  style: {"margin":"auto"},
  class: "col-xl-18 pb-3"
}
const _hoisted_31 = ["src"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mt-0 mb-5" }, null, -1))
const _hoisted_33 = {
  id: "ftr-fourth-row",
  class: "text-sm-center-var ftr-top"
}
const _hoisted_34 = {
  "data-designer": "ftr-col-center",
  style: {},
  class: "pb-3 row img-center"
}
const _hoisted_35 = ["src"]
const _hoisted_36 = ["src"]
const _hoisted_37 = ["src"]
const _hoisted_38 = ["src"]
const _hoisted_39 = /*#__PURE__*/_createStaticVNode("<div class=\"row flex-wrap text-center-var py-3 ftr-pay\" data-designer=\"ftr-pay\" data-v-51779527></div><p class=\"font-size-sm mb-5\" data-v-51779527> © 2019 - 2023 FOXIGY, <a href=\"https://profigarazs.admin.upgates.com\" target=\"_blank\" rel=\"nofollow noopener\" data-v-51779527>admin</a>, <a href=\"/sitemap\" class=\"text-lowercase\" data-v-51779527>Mapa stránky</a>, <a href=\"/feed-rss.xml\" data-v-51779527>RSS</a>, <span class=\"ContactModal\" data-toggle=\"modal\" data-target=\"#cookiesDialog\" data-id=\"Cookies\" data-v-51779527><a href=\"#\" class=\"d-inline d-sm-inline NoScroll\" data-v-51779527>Nastavenie cookies</a></span>, <a href=\"https://www.upgates.sk/pronajem-e-shopu?utm_source=paticka&amp;utm_medium=project&amp;utm_campaign=paticka\" title=\"Tvorba a prenájom e-shopu\" target=\"_blank\" data-v-51779527>prenájom e-shopu Upgates</a></p>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("link", {
      rel: "stylesheet",
      href: _ctx.criticalCss
    }, null, 8, _hoisted_2),
    _createElementVNode("link", {
      rel: "stylesheet",
      href: _ctx.afterCss
    }, null, 8, _hoisted_3),
    _createElementVNode("link", {
      rel: "stylesheet",
      href: _ctx.appCss
    }, null, 8, _hoisted_4),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("footer", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              class: "col-xl-22 pb-5 first-row ftr-menu",
              innerHTML: _ctx.navContent
            }, null, 8, _hoisted_9)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("aside", {
              class: "col-xl-7 pb-3 text-xl-left",
              itemscope: "",
              itemtype: "http://schema.org/LocalBusiness",
              innerHTML: _ctx.contactColumn
            }, null, 8, _hoisted_11),
            _createElementVNode("aside", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("strong", _hoisted_14, _toDisplayString(_ctx.localizator?.["footer"]["why-shop-with-us"]()), 1),
                (_ctx.heurekaImagePresent)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      (['si'].includes(_ctx.language))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16))
                        : (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            style: {"width":"100%"},
                            src: _ctx.baseUrl + _ctx.localizator?.['footer']['heureka-image-url']()
                          }, null, 8, _hoisted_17))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  "data-designer": "ftr-opn",
                  style: {},
                  class: _normalizeClass(["pb-3", _ctx.heurekaImagePresent ? 'col-18' : 'col-24'])
                }, [
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, _toDisplayString(_ctx.localizator?.["footer"]["benefits"]["first"]()), 1),
                    _createElementVNode("li", null, _toDisplayString(_ctx.localizator?.["footer"]["benefits"]["second"]()), 1),
                    _createElementVNode("li", null, _toDisplayString(_ctx.localizator?.["footer"]["benefits"]["third"]()), 1)
                  ])
                ], 2)
              ])
            ]),
            _createElementVNode("aside", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("iframe", {
                  class: "col-24 col-xl-20 col-sm-16",
                  src: _ctx.localizator?.['footer']['social']['facebook-plugin-url'](),
                  style: {"border":"none","overflow":"hidden"},
                  scrolling: "no",
                  allowfullscreen: "true",
                  allow: "autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share",
                  width: "340",
                  height: "130",
                  frameborder: "0"
                }, null, 8, _hoisted_21),
                _hoisted_22,
                _createElementVNode("a", {
                  class: _normalizeClass(["p-1", _ctx.footerSocialImgClass]),
                  href: _ctx.localizator?.['footer']['social']['facebook-page-url']()
                }, [
                  _createElementVNode("img", {
                    class: "footer-social-img",
                    src: _ctx.baseUrl + '/footer/img/facebook.webp'
                  }, null, 8, _hoisted_24)
                ], 10, _hoisted_23),
                _createElementVNode("a", {
                  class: _normalizeClass(["p-1", _ctx.footerSocialImgClass]),
                  href: _ctx.localizator?.['footer']['social']['youtube-page-url']()
                }, [
                  _createElementVNode("img", {
                    class: "footer-social-img",
                    src: _ctx.baseUrl + '/footer/img/youtube.webp'
                  }, null, 8, _hoisted_26)
                ], 10, _hoisted_25),
                _createElementVNode("a", {
                  class: _normalizeClass(["p-1", _ctx.footerSocialImgClass]),
                  href: _ctx.localizator?.['footer']['social']['instagram-page-url']()
                }, [
                  _createElementVNode("img", {
                    class: "footer-social-img",
                    src: _ctx.baseUrl + '/footer/img/instagram.webp'
                  }, null, 8, _hoisted_28)
                ], 10, _hoisted_27)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("aside", _hoisted_30, [
              _createElementVNode("img", {
                src: _ctx.baseUrl + _ctx.localizator?.['footer']['your-foxigy-image-link'](),
                style: {"width":"100%","align-self":"center !important"}
              }, null, 8, _hoisted_31)
            ])
          ]),
          _hoisted_32,
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("aside", _hoisted_34, [
              (_ctx.hasComgateEnabled)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: _normalizeClass(["ftr-payment-img", _ctx.footerPaymentMethodsImgClass]),
                    src: _ctx.baseUrl + '/footer/img/comgate.webp',
                    style: {}
                  }, null, 10, _hoisted_35))
                : _createCommentVNode("", true),
              _createElementVNode("img", {
                class: _normalizeClass(["ftr-payment-img", _ctx.footerPaymentMethodsImgClass]),
                src: _ctx.baseUrl + '/footer/img/visa.webp',
                style: {}
              }, null, 10, _hoisted_36),
              _createElementVNode("img", {
                class: _normalizeClass(["ftr-payment-img", _ctx.footerPaymentMethodsImgClass]),
                src: _ctx.baseUrl + '/footer/img/mastercard.webp',
                style: {}
              }, null, 10, _hoisted_37),
              _createElementVNode("img", {
                class: _normalizeClass(["ftr-payment-img", _ctx.footerPaymentMethodsImgClass]),
                src: _ctx.baseUrl + '/footer/img/maestro.webp',
                style: {}
              }, null, 10, _hoisted_38)
            ])
          ]),
          _hoisted_39
        ])
      ])
    ], 512)
  ]))
}